import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Trash2 } from "lucide-react";
import { api, imgUrl } from "@/lib/api";
import { useSeo, useShop } from "@/lib/shop";
import { ProductGrid } from "@/components/site/ProductCard";
import { GridSkeleton, Empty, ErrorState } from "@/components/site/States";

export default function Favorites() {
  useSeo("Produk Favorit");
  const { favs, toggleFav } = useShop();
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["favs", favs],
    queryFn: () => api.get("/products/by-ids", { params: { ids: favs.join(",") } }).then((r) => r.data),
    enabled: favs.length > 0,
  });
  const found = new Set((data || []).map((p) => p.id));
  const active = (data || []).filter((p) => p.available);
  const inactive = (data || []).filter((p) => !p.available);
  const missing = favs.filter((id) => data && !found.has(id));
  return (
    <div className="container-x py-10" data-testid="favorites-page">
      <h1 className="font-heading text-3xl sm:text-4xl font-extrabold">Produk Favorit</h1>
      <p className="text-neutral-600 mt-2 text-sm">Favorit disimpan di browser ini, tanpa perlu akun.</p>
      <div className="mt-8">
        {!favs.length ? (
          <Empty title="Belum ada favorit" text="Tekan ikon hati pada produk untuk menyimpannya di sini." action={<Link to="/katalog" className="btn-brand" data-testid="fav-browse-btn">Jelajahi Katalog</Link>} />
        ) : isLoading ? <GridSkeleton n={4} /> : isError ? <ErrorState onRetry={refetch} /> : (
          <>
            {active.length > 0 && <ProductGrid items={active} />}
            {(inactive.length > 0 || missing.length > 0) && (
              <div className="mt-10" data-testid="fav-unavailable">
                <h2 className="font-heading font-bold text-lg mb-3">Sudah tidak tersedia</h2>
                <div className="space-y-2">
                  {inactive.map((p) => (
                    <div key={p.id} className="flex items-center gap-3 rounded-xl border bg-white p-3 opacity-80">
                      <img src={imgUrl(p.images?.[0])} alt="" className="h-14 w-14 rounded-lg object-cover grayscale" />
                      <div className="flex-1 min-w-0"><div className="font-semibold truncate">{p.name}</div><div className="text-xs text-neutral-500">Produk tidak aktif dan tidak dapat dipesan.</div></div>
                      <button data-testid={`fav-remove-${p.id}`} onClick={() => toggleFav(p.id)} className="h-10 w-10 grid place-items-center rounded-lg border" aria-label="Hapus"><Trash2 className="h-4 w-4" /></button>
                    </div>
                  ))}
                  {missing.map((id) => (
                    <div key={id} className="flex items-center gap-3 rounded-xl border bg-white p-3 text-sm text-neutral-600">
                      <span className="flex-1">Produk telah dihapus dari katalog.</span>
                      <button onClick={() => toggleFav(id)} className="h-10 w-10 grid place-items-center rounded-lg border" aria-label="Hapus"><Trash2 className="h-4 w-4" /></button>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
